import React from "react";
import { Inbox } from "lucide-react";

export default function EmptyState({ title, message, children, icon: Icon = Inbox, testId }) {
  return (
    <div data-testid={testId || "empty-state"} className="text-center py-14 px-4">
      <svg viewBox="0 0 200 200" className="w-28 h-28 mx-auto mb-4 opacity-60" fill="none">
        <defs>
          <linearGradient id="tvGradient" x1="0" y1="0" x2="1" y2="1">
            <stop offset="0%" stopColor="#38BDF8" />
            <stop offset="100%" stopColor="#FACC15" />
          </linearGradient>
        </defs>
        <rect x="22" y="40" width="156" height="110" rx="10" stroke="url(#tvGradient)" strokeWidth="3" />
        <rect x="38" y="56" width="124" height="78" rx="4" fill="#0B1120" />
        <circle cx="100" cy="95" r="20" stroke="url(#tvGradient)" strokeWidth="2.5" />
        <path d="M92 87 v18 l14 -9 z" fill="url(#tvGradient)" />
        <path d="M70 160 L130 160" stroke="url(#tvGradient)" strokeWidth="3" strokeLinecap="round" />
        <circle cx="65" cy="170" r="3" fill="#FACC15" />
        <circle cx="135" cy="170" r="3" fill="#38BDF8" />
      </svg>
      <div className="font-display font-bold text-2xl text-white">{title}</div>
      {message && <div className="text-white/60 mt-2 max-w-md mx-auto">{message}</div>}
      {children && <div className="mt-6">{children}</div>}
    </div>
  );
}
